
// reactstrap components
import {
    Container,
} from "reactstrap";

const Header = (props) => {
    return (
        <>
        <div className="header bg-lightgray pb-6 pt-5 pt-md-3">
                <Container fluid>
                    <div className="header-body">
                    </div>
                </Container>
            </div>
            
        </>
    );
};

export default Header;
